<template>
  <div class="btn-box">
    <vxe-button type="text" status="primary" v-for="(btn) in btn.top" :key="btn.btncode" class="btn-item" :icon="btn.btnicon ? btn.btnicon : 'el-icon-connection' "  @click.native="btnClick(btn.btncode)">{{btn.btnname}}</vxe-button>
    <!-- <el-button-group>
        <el-button v-for="(btn, index) in authBtns" :key="index" @click.native="btnClick(btn.btncode)" style="margin-bottom: 5px" :loading="btnLoading">{{btn.btnname}}
        </el-button>
    </el-button-group> -->
  </div>
</template>

<script>
  import request from  '@/utils/request'
  export default {
    name: 'menuBtn',
    props: {
      menuid: '',
      btnLoading: false
    },
    data () {
      return {
        authBtns: [],
        btn:{
          top:[],
          right:[],
          inner:[]
        }
      }
    },
    activated(){
      // this.getAuthMenuBtn()
      // this.init()
    },
    created () {
      this.getAuthMenuBtn()
      this.init()
    },
    deactivated () {
      Object.assign(this.$data, {})
    },
    components: {},
    methods: {
      async init(){
        this.authBtns = {}
        this.btn = {
          top:[],
          right:[],
          inner:[]
        }
      },
      async getAuthMenuBtn () {
        this.authBtns = await request({
          method: 'get',
          url: '/kfgl/menu/getAuthMenuBtn',
          params: {menuid: this.menuid, userid: this.$store.getters.loginUser.userid}
        })
        // btn={
        //   top:[],
        //   right:[],
        //   inner:[]
        // }
        this.authBtns.forEach(key => {
          if(key.menubtnposition === 1){
            this.btn.top.push(key)
          }
          if(key.menubtnposition === 2){
            this.btn.right.push(key)
          }
          if(key.menubtnposition === 3){
            this.btn.inner.push(key)
          }
        });
        if(this.btn.right.length > 0){
          this.btn.isOperate = true
        }else{
          this.btn.isOperate = false
        }
        this.$emit('btnmenuclick', this.btn)
      },
      btnClick (code) {
        this.$emit('btnClick', code,this.btn)
      }
    },
    computed: {
    }
  }
</script>

<style lang="scss" scoped>
.btn-box{
  overflow: hidden;
    .vxe-button{
      padding: 10px 10px;
      font-size: 16px;
    }
}
</style>
